<template>
  <div class="wt2-sg wt-in-out-animation-box no-select">
    <div class="-group-title wt2-text-n2">Select Animation</div>

    <div class="-group" @click="dumpContext($event, listInAnimations)">
      <div class="-group-label">In</div>
      <wt-dropdown-view ref="ddvIn" :label="activeInAnimText">
        <template slot="view">
          <div class="-list">
            <animation-item
              v-for="anim in listInAnimations"
              :key="anim.id"
              :anim="anim"
              :selected="anim.id === activeInAnim"
              @click.native="setActiveInAnim(anim.id)"
            />
          </div>
        </template>
      </wt-dropdown-view>
    </div>

    <div class="-group" @click="dumpContext($event, listOutAnimations)">
      <div class="-group-label">Out</div>
      <wt-dropdown-view ref="ddvOut" :label="activeOutAnimText" type="right">
        <template slot="view">
          <div class="-list">
            <animation-item
              v-for="anim in listOutAnimations"
              :key="anim.id"
              :anim="anim"
              :selected="anim.id === activeOutAnim"
              @click.native="setActiveOutAnim(anim.id)"
            />
          </div>
        </template>
      </wt-dropdown-view>
    </div>
  </div>
</template>

<script>
import app from 'app';
import AnimationItem from './AnimationItem.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'in-out-animation-picker',
  components: {
    AnimationItem,
  },

  data: () => {
    return {
      visible: false,
    };
  },

  computed: {
    ...mapGetters('assetEditor', ['themeInfo', 'pageTmpState']),

    ANIMATION() {
      return app.ANIMATION;
    },

    listInAnimations: function () {
      const rv = [this.ANIMATION.NONE];
      const filtered = _.filter(this.themeInfo.animationPresets, (anim) => {
        return !_.some(rv, { id: anim.id });
      });
      return rv.concat(filtered);
    },

    listOutAnimations: function () {
      const rv = [this.ANIMATION.NONE, this.ANIMATION.CONTINUE];
      const filtered = _.filter(this.themeInfo.animationOutPresets, (anim) => {
        return !_.some(rv, { id: anim.id });
      });
      return rv.concat(filtered);
    },

    activeTextOverlay: function () {
      return this.pageTmpState.textOverlay;
    },

    lastActiveInAnim: function () {
      if (this.pageTmpState.lastActiveTo) {
        return this.pageTmpState.lastActiveTo.animationId;
      }
      return null;
    },

    activeInAnim: function () {
      let id = null;
      if (
        this.activeTextOverlay &&
        !_.isEmpty(this.activeTextOverlay.animationId)
      ) {
        id = this.activeTextOverlay.animationId;
      }
      return id;
    },

    activeOutAnim: function () {
      let id = null;
      if (
        this.activeTextOverlay &&
        !_.isEmpty(this.activeTextOverlay.animationOutId)
      ) {
        id = this.activeTextOverlay.animationOutId;
      }
      if (!id) {
        id = app.ANIMATION.CONTINUE.id;
      }
      return id;
    },

    activeInAnimText: function () {
      if (!this.activeInAnim) {
        return '';
      }
      const activeId = this.activeInAnim || this.lastActiveInAnim;
      const anim = this.animIn(activeId);
      return anim ? anim.displayText : '';
    },

    activeOutAnimText: function () {
      if (!this.activeInAnim) {
        return '';
      }

      const activeId = this.activeOutAnim;
      let useDefault = false;
      let displayText = '';

      const animOut = this.animOut(activeId);
      if (!animOut) {
        useDefault = true;
      } else {
        displayText = animOut.displayText;
      }

      if (useDefault) {
        const animIn = this.animIn(this.activeInAnim);
        const animOut = animIn && this.animOut(animIn.continueId);
        displayText = (animOut && animOut.displayText) || '';
      }

      return displayText;
    },
  },

  watch: {
    activeTextOverlay(to) {
      this.visible = !!to;
    },
  },

  methods: {
    ...mapMutations('assetEditor', ['setTempTextOverlay']),

    dumpContext(e, context) {
      if (e.metaKey || e.ctrlKey) {
        this.$log(context);
      }
    },

    setActiveInAnim(id) {
      if (this.activeTextOverlay) {
        this.$refs.ddvIn.close();
        this.setTempTextOverlay({
          id: this.activeTextOverlay.id,
          animationId: id,
        });
      }
    },

    setActiveOutAnim(id) {
      if (this.activeTextOverlay) {
        this.$refs.ddvOut.close();
        this.setTempTextOverlay({
          id: this.activeTextOverlay.id,
          animationOutId: id,
        });
      }
    },

    animIn(id) {
      return _.find(this.themeInfo.animationPresets, (a) => a.id === id);
    },

    animOut(id) {
      return _.find(this.themeInfo.animationOutPresets, (a) => a.id === id);
    },
  },
};
</script>
